import type { BaseQueryApi } from '@reduxjs/toolkit/query';
import { REFRESH_TOKEN_CONFIG } from '../refreshToken/refreshTokenConstants';

/**
 * Checks if error requires token refresh
 * Handles 401 Unauthorized errors
 *
 * @param errorStatus - The error status from the API response
 * @returns true if token refresh should be attempted
 */
export function shouldAttemptRefresh(errorStatus: string | number | undefined): boolean {
  return errorStatus === REFRESH_TOKEN_CONFIG.HTTP_STATUS_UNAUTHORIZED;
}

/**
 * Handles logout and redirect to signin page
 * Note: logout action should be dispatched by the calling app
 * 
 * @param api - RTK Query API object with dispatch
 * @param logoutAction - The logout action from the app's auth slice
 */
export function handleLogout(api: BaseQueryApi, logoutAction: any): void {
  api.dispatch(logoutAction());

  if (window.location.pathname !== '/signin') {
    window.location.replace('/signin');
  }
}

